import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

import GetStarted from '../GetStarted';

import './Terms.css';

class Terms extends Component {
  render() {
    return (
      <div className="Terms">
        <Helmet>
          <title>Terms of use - Qbates</title>
          <meta name="description" content="Qbates Terms of use" />
        </Helmet>
        <GetStarted/>
        <h3>Terms of use</h3>
        <p> Terms of use</p>
        <div className="back">
          <Link to="/register"><button>GO BACK</button></Link>
        </div>
      </div>
    );
  }
}

export default Terms;


// WEBPACK FOOTER //
// ./src/Containers/GetStarted/components/Terms.js